<template>

    <div class="panel-wrapper">

        <!-- HEADER -->
        <div class="header" :style="{ backgroundColor: cssPropColor('$color-primary') }">
            <span class="icon">
                <label @click="closePanel($event)" for="panel-toggle" title="Close"><i class="icon-MBR_close" aria-hidden="true"></i></label>
            </span>
            <span class="label" v-html="addCoverageLabel"></span>
        </div>
        <!-- END HEADER -->

        <!-- CONTENT -->
        <div class="panel-content" data-simplebar>

            <ul class="accordion">

                <!-- SERVICE LINE COVERAGE -->
                <li data-type="service-line" v-if="hasServiceLineCoverages">

                    <a id="anchor_service-line" name="anchor_service-line"></a>

                    <input type="checkbox" id="tab-service-line" name="outer-tabs[]" data-coverage="service-line" :checked="service" @change="toggleOuterCheck($event, 'tab-service-line')" />

                    <label for="tab-service-line" class="tab-heading">
                        <h3 v-html="serviceLineLabel"></h3>
                    </label>

                    <div class="tab-content">

                        <!-- LEAD-IN -->
                        <div class="lead-in service-line" v-html="serviceLineLeadIn" v-if="serviceLineLeadIn"></div>
                        <!-- END LEAD-IN -->

                        <!-- COVERAGE LINKS -->
                        <ul class="coverage-links">
                            <li v-for="coverage in serviceLineCoverages"><a @click="togglePanel('panel-content-exposure', coverage.exposure_slug, $event, true, false)" v-html="coverage.exposure_label"></a></li>
                        </ul>
                        <!-- END COVERAGE LINKS -->

                    </div>

                    <hr />

                </li>
                <!-- END SERVICE LINE COVERAGE -->

                <!-- OFF PREMISE COVERAGE -->
                <li data-type="off-premise" v-if="hasOffPremiseCoverages">

                    <a id="anchor_off-premise" name="anchor_off-premise"></a>

                    <input type="checkbox" id="tab-off-premise" name="outer-tabs[]" data-coverage="off-premise" :checked="premise" @change="toggleOuterCheck($event, 'tab-off-premise')" />

                    <label for="tab-off-premise" class="tab-heading">
                        <h3 v-html="offPremiseLabel"></h3>
                    </label>

                    <div class="tab-content">

                        <!-- LEAD-IN -->
                        <div class="lead-in" v-html="offPremiseLeadIn" v-if="offPremiseLeadIn"></div>
                        <!-- END LEAD-IN -->

                        <!-- COVERAGE LINKS -->
                        <ul class="coverage-links">
                            <li v-for="coverage in offPremiseCoverages"><a @click="togglePanel('panel-content-exposure', coverage.exposure_slug, $event, false, true)" v-html="coverage.exposure_label"></a></li>
                        </ul>
                        <!-- END COVERAGE LINKS -->

                    </div>

                    <hr />

                </li>
                <!-- END OFF PREMISE COVERAGE -->

            </ul>

            <div class="contact-link">
                <span v-html="contact.text"></span> <br /><a @click="togglePanel2('panel-content-contact', 'contact-us', $event, false, false)" v-html="contact.link.label"></a>
            </div>

        </div>
        <!-- END CONTENT -->

    </div>

</template>


<script>

    let vm = {};

    export default {

        name: 'panel-content-coverages',

        props: [
            'panel',
            'slug',
            'service',
            'premise'
        ],

        components: {},

        data() {
            return {
                contact: {
                    text: 'Ready to take the next step?',
                    link: {
                        label: 'Contact us today'
                    }
                }
            }
        },

        computed: {

            coverages() {
                return this.$dataStore.getters.getCoverages;
            },

            addCoverageLabel() {
                return this.$dataStore.getters.getAdditionalCoveragesLabel;
            },

            serviceLineLabel() {
                return this.$dataStore.getters.getServiceLineCoverageLabel;
            },

            serviceLineLeadIn() {
                let _occupancies = this.$dataStore.getters.getOccupancies;
                return _occupancies.occupancy_service_line_lead_in;
            },

            serviceLineCoverages() {
                let coverages = this.$dataStore.getters.getCoveragesByType('service-line');
                return _.sortBy(coverages, ['exposure_label']);
            },

            hasServiceLineCoverages() {
                return this.$dataStore.getters.getServiceLineCoverages.length;
            },

            offPremiseLabel() {
                return this.$dataStore.getters.getOffPremiseCoverageLabel;
            },

            offPremiseLeadIn() {
                let _occupancies = this.$dataStore.getters.getOccupancies;
                return _occupancies.occupancy_off_premise_lead_in;
            },

            offPremiseCoverages() {
                let coverages = this.$dataStore.getters.getCoveragesByType('off-premise');
                return _.sortBy(coverages, ['exposure_label']);
            },

            hasOffPremiseCoverages() {
                return this.$dataStore.getters.getOffPremisesCoverages.length;
            }

        },

        created() {},

        mounted() {

            vm = this;

            // scroll to tab & check it
            let _s = vm.slug,
                _checkEl = document.querySelectorAll('[data-coverage="' + _s + '"]')[0];

            if (typeof _checkEl !== 'undefined') {
                _checkEl.checked = true;
                vm.scrollToAnchor(vm.slug);
            }

            vm.playVideo();
            vm.initCarousel();

        },

        methods: {

            /**
             * @method playVideo
             * @description
             */
            playVideo() {
                let _video = $('.video-player-element');

                if (!_video.length) { return; }

                _.each(_video, function(val, key) {

                    // video `canplay` event handler
                    $(val).on('canplay', function() {
                        $(val).trigger('play');
                    });

                    // check `readyState` in case video element has already been init'd/cached
                    if ($(val)[0].readyState > 3) {
                        $(val).trigger('play');
                    }

                });
            },

            /**
             * @method initCarousel
             * @description
             */
            initCarousel() {

                let _carousel = $('.image-carousel');

                if (!_carousel.length) { return; }

                vm.carousel = true;

                _.each(_carousel, function(val, key) {

                    $(val).slick({
                        autoplay: true,
                        arrows: false,
                        pauseOnHover: false,
                        pauseOnFocus: false
                    });

                });

            },

            /**
             * @method scrollToAnchor
             * @description
             */
            scrollToAnchor(slug) {

                let _anchorId = 'anchor_' + slug,
                    _anchorEl = document.getElementById(_anchorId);

                let requestAnimFrame = (function() {
                    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
                        window.setTimeout(callback, 1000 / 60);
                    };
                })();

                Math.easeInOutQuad = function(t, b, c, d) {
                    t /= d / 2;
                    if (t < 1) {
                        return c / 2 * t * t + b
                    }
                    t--;
                    return -c / 2 * (t * (t - 2) - 1) + b;
                };

                Math.easeInCubic = function(t, b, c, d) {
                    let tc = (t /= d) * t * t;
                    return b + c * (tc);
                };

                Math.inOutQuintic = function(t, b, c, d) {
                    let ts = (t /= d) * t,
                        tc = ts * t;
                    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
                };

                function isDomElement(obj) {
                    return obj instanceof Element;
                }

                function scrollTo(to, callback, duration = 1500) {

                    if (isDomElement(to)) {
                        to = to.offsetTop;
                    }

                    // because it's so fucking difficult to detect the scrolling element, just move them all
                    function move(amount) {
                        document.documentElement.scrollTop = amount;
                        document.body.parentNode.scrollTop = amount;
                        document.body.scrollTop = amount;
                    }

                    function position() {
                        return document.documentElement.offsetTop || document.body.parentNode.offsetTop || document.body.offsetTop;
                    }

                    let start = position(),
                        change = to - start,
                        currentTime = 0,
                        increment = 20;

                    let animateScroll = function() {
                        // increment the time
                        currentTime += increment;
                        // find the value with the quadratic in-out easing function
                        let val = Math.easeInOutQuad(currentTime, start, change, duration);
                        // move the document.body
                        move(val);
                        // do the animation unless its over
                        if (currentTime < duration) {
                            requestAnimFrame(animateScroll);
                        } else {
                            if (callback && typeof(callback) === 'function') {
                                // the animation is done so lets callback
                                callback();
                            }
                        }
                    };

                    animateScroll();
                }

                scrollTo(_anchorEl);

            },

            /**
             * @method toggleCheck
             * @description
             * @param evt
             * @param slug
             */
            toggleCheck(evt, slug) {

                $('.image-carousel').slick('setPosition');

                let _checks = $('input[name="tabs-service[]"]');

                _.each(_checks, function(val) {
                    if (evt.currentTarget.id !== $(val).attr('id')) {
                        $(val).prop('checked', false);
                    }
                });

                vm.scrollToAnchor(slug);

            },

            /**
             * @method toggleOuterCheck
             * @description
             * @param evt
             * @param slug
             */
            toggleOuterCheck(evt, slug) {

                $('.image-carousel').slick('setPosition');

                let _checks = $('input[name="outer-tabs[]"]');

                _.each(_checks, function(val) {
                    if (evt.currentTarget.id !== $(val).attr('id')) {
                        $(val).prop('checked', false);
                    }
                });

                vm.scrollToAnchor(slug);

            },

            /**
             * @method togglePanel
             * @description
             * @param {String} type
             * @param {String} slug
             * @param {Object} evt
             * @param {Boolean} service
             * @param {Boolean} premise
             */
            togglePanel(type, slug, evt, service, premise) {
                evt.stopPropagation();
                this.$eventBus.$emit('panel:toggle', { panel: type, slug: slug, service: service, premise: premise });
                this.$eventBus.$emit('points:state:active', slug);
                this.$eventBus.$emit('residence:zoomto', { slug: slug });
            },

            /**
             * @method togglePanel
             * @description
             * @param {String} type
             * @param {String} slug
             * @param {Object} evt
             * @param {Boolean} service
             * @param {Boolean} premise
             */
            togglePanel2(type, slug, evt, service, premise) {
                evt.stopPropagation();
                this.$eventBus.$emit('panel:toggle', { panel: type, slug: slug, service: service, premise: premise });
            },

            closePanel(evt){
                vm.$eventBus.$emit('residence:zoomout');
            },

            /**
             * @method cssPropColor
             * @description
             * @param colorProp
             * @return {boolean}
             */
            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }

        },

        beforeDestroy() {
            if (vm.carousel) { $('.image-carousel').slick('unslick'); }
        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .panel-wrapper {
        height: 100%;
        position: relative;
        animation-duration: 0s;
        animation-delay: 0.6s;
    }

    .panel-content {

        & .accordion {
            list-style-type: none;
            margin: 0 0 0 0;
            padding: 0 0 0 0;

            & > li {
                width: 100%;
                margin: 0 0 0 0;
                padding: 0 0 0 0;
                display: block;
                overflow: hidden;
                position: relative;

                &:first-of-type {
                    padding: 1rem 0 0 0;
                }

                &:last-of-type {
                    padding: 0 0 1rem 0;
                }

                & > hr {
                    margin: 0 1.875rem;
                }
            }
        }

        & .tab-heading {
            padding: 0 0 0 0;
            display: block;
            position: relative;
            cursor: pointer;

            &::after {
                line-height: 3.813;
                width: 3rem;
                height: 3rem;
                display: block;
                position: absolute;
                top: 0;
                right: 1rem;
                transition: all 0.3s $easeInOutQuad;
            }

            & > h3 {
                font-family: $font-univers-bold;
                font-size: 1.0rem;
                font-weight: normal;
                text-align: left;
                line-height: 1;
                letter-spacing: 0;
                color: rgba(76,76,76, 1.0);
                margin: 0 0 0 0;
                padding: 1.125rem 1.875rem;
            }
        }

        & .tab-content {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.3s $easeInOutQuad;

            & > .lead-in {
                padding: 0.5rem 1.875rem 0;

                &.service-line {
                    padding: 0.5rem 1.875rem 0;
                }
            }

            & .coverage-links {
                text-align: left;
                color: var(--color-primary);
                list-style-type: disc;
                margin-top: 0.25rem;

                & > li {
                    letter-spacing: normal;
                    margin: 0 0 0 0;
                    padding: 0 0 0 0;
                }
            }
        }

        & input[type="checkbox"],
        & input[type="radio"] {
            opacity: 0;
            position: absolute;
            z-index: -1;

            & + label::after {
                content: '\e900';
                font-family: 'icomoon' !important;
                font-size: 0.875rem;
                font-weight: 600;
                font-style: normal;
                font-variant: normal;
                text-transform: none;
                color: rgba(76,76,76, 1.0);
            }

            &:checked {

                & + label {

                    &::after {
                        content: '\e908';
                        color: var(--color-primary);
                    }

                    & h3 {
                        color: var(--color-primary);
                    }
                }

                & ~ .tab-content {
                    max-height: 100rem;
                }

            }
        }


        & .lead-in {
            font-family: $font-univers-std;
            font-size: 0.875rem;
            font-weight: normal;
            line-height: 1.438;
            letter-spacing: 0;
            text-align: left;
            padding: 1.75rem 1.875rem;
        }

        & .media {

            & .image-carousel {
                line-height: 0;

                & img {
                    width: 100%;
                    height: auto;
                }
            }
        }

        & .body {
            font-family: $font-univers-std;
            font-size: 0.875rem;
            font-weight: normal;
            line-height: 1.438;
            letter-spacing: 0;
            text-align: left;
            color: rgba(76,76,76, 1.0);

            & h3 {
                font-family: $font-univers-bold;
                font-size: 1rem;
                font-weight: normal;
                line-height: 1;
                letter-spacing: 0;
                text-transform: none;
                text-align: left;
                //color: rgba(76,76,76, 1.0);
                margin: 0 0 12px 0;
            }

            & section {

                &:last-of-type {

                    & hr {
                        display: none;
                    }
                }
            }
        }

        & .contact-link {
            font-family: $font-univers-std;
            font-size: 0.875rem;
            font-weight: normal;
            line-height: 1.438;
            letter-spacing: 0;
            text-align: center;
            padding: 1rem 1.875rem 2rem;
        }

        & video {
            width: 100% !important;
            height: auto !important;
        }
    }

</style>


// WEBPACK FOOTER //
// PanelContentCoverages.vue?13f34a7c